import { render, staticRenderFns } from "./view.vue?vue&type=template&id=f51f1f50&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"
import style0 from "./view.vue?vue&type=style&index=0&id=f51f1f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51f1f50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f51f1f50')) {
      api.createRecord('f51f1f50', component.options)
    } else {
      api.reload('f51f1f50', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=f51f1f50&scoped=true&", function () {
      api.rerender('f51f1f50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/view.vue"
export default component.exports